import { Injectable } from "@angular/core";
import { AbstractParser } from "../../parser";

@Injectable()
export class AddContactParser extends AbstractParser<any> {
  parse(payload: any): any {
    let message = "";
    if (payload) {
      message = payload.error.Data.ErrorMessage;
    }
    return message;
  }
}
